/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useMemo } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// material-ui icons
import Assignment from "@material-ui/icons/Assignment";
// import Person from "@material-ui/icons/Person";
// import Edit from "@material-ui/icons/Edit";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Slider from "nouislider";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
// core components
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Datetime from "react-datetime";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "../../utils/axiosInstance";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { MantineReactTable } from "mantine-react-table";
import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";
// import Person from "@material-ui/icons/Person";
// import Edit from "@material-ui/icons/Edit";
import {
  Box,
  ActionIcon,
  Tooltip,
  Modal,
  Flex,
  Title,
  Stack,
  TextInput,
} from "@mantine/core";

import { IconTrash, IconEdit, IconEye } from "@tabler/icons-react";

import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import RichTextEditor from "react-rte";
const useStyles = makeStyles(styles);
import SweetAlert from "react-bootstrap-sweetalert";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
//const baseURL = "https://jsonplaceholder.typicode.com/api/v1/admin/login";
const useStyleData = makeStyles(stylesData);

export default function ManageLotteries() {
  const location = useLocation();
  const addFaq = location.pathname.includes("addFAQ");
  const [users, setUsers] = useState([]);
  const classes = useStyles();
  const navigate = useNavigate();
  const [rowValaue, setRowValue] = useState({});
  const [formValues, setFormValues] = React.useState({
    question: "",
    answer: " ",
    _id: " ",
  });
  const [openView, setOpenView] = useState(false);

  const [openEditModal, setOpenEditModal] = useState(false);
  const columns = useMemo(() => [
    {
      header: "Question",
      accessorKey: "question",
      size: 10,
    },
    {
      header: "Answer",
      accessorKey: "answer",
      size: 10,
    },
  ]);
  const [values, setValues] = useState(() =>
    columns?.reduce((acc, column) => {
      acc[column.accessorKey ?? ""] = "";
      return acc;
    })
  );
  const [validationErrors, setValidationErrors] = useState({});
  const [tableData, setTableData] = useState([]);
  const [alert, setAlert] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [editorBody, setEditorBody] = React.useState(
    RichTextEditor.createEmptyValue()
  );

  const handleEditorChange = (newValue) => {
    setEditorBody(newValue);
    setFormValues({
      ...formValues,
      answer: newValue.toString("html"),
    });
  };
  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.id]:
        e.target.type === "number" ? Number(e.target.value) : e.target.value,
    });
    console.log(formValues);
  };

  const handleSubmitForm = async (row, id) => {
    const token = localStorage.getItem("token");
    const formData = new FormData();
    //setSelectedFile(e.target.files[0]);
    for (const key in formValues) {
      formData.append(key, formValues[key]);
    }
    //const newFormValue= Object.assign(formValues,{"image":imageurl});

    axios
      .put(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/faq/${formValues._id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // 'Content-Type': 'application/json',
            // "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        console.log(res);
        setAlert(
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {res.data.message}
              </span>
            }
           onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
            titleCssClass={classesSweetAlert.cardTitle}
            confirmBtnCssClass={
              classesSweetAlert.button + " " + classesSweetAlert.success
            }
          />
        );
        setOpenEditModal(false);
        getData();
      })
      .catch((err) => {
        console.warn(err);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const hideAlert = () => {
    setAlert(null);
  };

  const getData = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    console.log(token);
    await axios
      .get(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/faq`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        console.log(res);
        setUsers(res.data.data);
      })

      .catch((err) => {
        console.log(err);
        if (err.response.data.message == "For security reasons, we locked your account.Please login to continue") {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      }).finally(() => {
        setLoading(false);
      });
  };

  const handleDelete = async (row) => {
    const token = localStorage.getItem("token");
    //console.log(userId);
    if (confirm("Are you sure you want to delete")) {
      await axios
        .delete(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/faq/${row.original._id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((data) => {
          setAlert(
            <SweetAlert
              style={{ display: "block", marginTop: "-100px" }}
              title={
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  {data.data.message}
                </span>
              }
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              titleCssClass={classesSweetAlert.cardTitle}
              confirmBtnCssClass={
                classesSweetAlert.button + " " + classesSweetAlert.success
              }
            />
          );
          getData();
        })
        .catch((err) => {
          if (err.response.data.message == "For security reasons, we locked your account.Please login to continue") {
            localStorage.removeItem("token");
            window.location.assign("/auth/login-page");
          }
        });
    } else {
      console.log("FAQ are not deleted");
    }
  };



  const handleCancelRowEdits = () => {
    setValidationErrors({});
  };
  const handleOpenEditModal = async (row) => {
    setOpenEditModal(true);
    const token = localStorage.getItem("token");
    await axios
      .get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/faq/${row.original._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        setFormValues({
          _id: res.data.data._id,
          question: res.data.data.question,
          answer: res.data.data.answer,
        });
        setEditorBody(
          RichTextEditor.createValueFromString(res.data.data.answer, "html")
        );
      })

      .catch((err) => {
        console.log(err);
        if (err.response.data.message == "For security reasons, we locked your account.Please login to continue") {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      });
  };

  const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
    const token = localStorage.getItem("token");
    exitEditingMode(); //required to exit editing mode and close modal
    let formDataValue = {
      question: formValues.question,
      answer: formValues.answer,
    };
    await axios
      .put(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/faq/faqId=${formValues._id}`,
        formDataValue,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        setAlert(
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {res.data.message}
              </span>
            }
            onConfirm={() => hideAlert()}
            onCancel={() => hideAlert()}
            titleCssClass={classesSweetAlert.cardTitle}
            confirmBtnCssClass={
              classesSweetAlert.button + " " + classesSweetAlert.success
            }
          />
        );
        getData();
      })

      .catch((err) => {
        console.log(err);
        if (err.response.data.message == "For security reasons, we locked your account.Please login to continue") {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      });
  };
  const handleModalView = (row) => {
    setRowValue(row.original); // Set the selected row data
    setOpenView(true);         // Open the modal
  };
  const classesSweetAlert = useStyleData();
  return (
    <>
      {!addFaq && (
        <>
          <GridContainer>
            <GridItem xs={12}>
              <Card>
                <CardHeader color="rose" icon>
                  <CardIcon color="rose">
                    <Assignment />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>Manage FAQ</h4>
                  <Button
                    color="#3C37FF"
                    style={{ float: "right" }}
                    onClick={() => navigate("/admin/manage-pages/faq/addFAQ")}
                  >
                    Add Faq
                  </Button>
                </CardHeader>
                <CardBody>
                  <MantineReactTable
                    columns={columns}
                    data={users}
                    enableRowNumbers={false}
                    positionActionsColumn="first"
                    displayColumnDefOptions={{
                      "mrt-row-actions": {
                        mantineTableHeadCellProps: {
                          align: "center",
                        },
                        size: 120,
                      },
                    }}
                    enableEditing
                    enableFullScreenToggle={false}
                    enableHiding={false}
                    enableDensityToggle={false}
                    enableFilters={false}
                    enablePagination={false}
                    positionToolbarAlertBanner="bottom"
                    onEditingRowSave={handleSaveRowEdits}
                    onEditingRowCancel={handleCancelRowEdits}
                    renderRowActions={({ row }) => (
                      <Box sx={{ display: "flex" , justifyContent: "center", marginLeft: "10px" }}>
                        <Tooltip withArrow position="left" label="Edit">
                          <ActionIcon
                            onClick={() => handleModalView(row)}
                          >
                            <IconEye />
                          </ActionIcon>
                          </Tooltip>
                          <Tooltip withArrow position="left" label="View">
                            <ActionIcon onClick={() => handleOpenEditModal(row)}>
                              <IconEdit />
                            </ActionIcon>
                          </Tooltip>
                        <Tooltip withArrow position="right" label="Delete">
                          <ActionIcon color="red" onClick={() => handleDelete(row)}>
                            <IconTrash />
                          </ActionIcon>
                        </Tooltip>
                      </Box>
                    )} 
                  />

                </CardBody>
              </Card>
            </GridItem>
            {alert}
          </GridContainer>
          <Modal opened={openView} onClose={() => setOpenView(false)}>
            <Title ta="center">View Faq</Title>
            <Stack sx={{ width: "100%" }}>
              {columns.map((column) => (
                <TextInput
                  key={column.accessorKey}
                  readOnly
                  label={column.header}
                  name={column.accessorKey}
                  value={rowValaue[column.accessorKey] || ""}
                />
              ))}
            </Stack>
            <Flex
              sx={{
                padding: "20px",
                width: "100%",
                justifyContent: "flex-end",
                gap: "16px",
              }}
            >
              <Button onClick={() => setOpenView(false)} variant="subtle">
                Cancel
              </Button>
            </Flex>
          </Modal>
          <Modal opened={openEditModal} onClose={() => setOpenEditModal(false)}>
            <Title ta="center">Edit Faq</Title>
            <Stack
              sx={{
                width: "100%",
              }}
            >
              <form>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="question"
                      id="question"
                      handleChange={handleChange}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "text",
                        value: formValues?.question,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12}>
                    <RichTextEditor
                      value={editorBody}
                      onChange={handleEditorChange}
                      style={{ height: "300px" }}
                    />
                  </GridItem>
                </GridContainer>
              </form>
            </Stack>
            <Flex
              sx={{
                padding: "20px",
                width: "100%",
                justifyContent: "flex-end",
                gap: "16px",
              }}
            >
              <Button onClick={() => handleSubmitForm(rowValaue)}>Save</Button>
              <Button onClick={() => setOpenEditModal(false)} variant="subtle">
                Cancel
              </Button>
            </Flex>
          </Modal>
        </>
      )}

      <Outlet />
    </>
  );
}
